import BusinessUnit from '../BusinessUnits/Model';
export default class OperationLine {
    constructor(props) {
        Object.assign(this, props);
        if (props.businessUnit) {
            this.businessUnit = new BusinessUnit(props.businessUnit);
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/OperationLines/Model.ts
// module id = 347
// module chunks = 0